module.exports = __webpack_public_path__ + "img/oie-startsida-puff-01.jpg";